import { constants } from '../../helpers';
import {
  changeCollectionsEconomicAccountingFilterStartBusinessDate,
  changeCollectionsEconomicAccountingFilterEndBusinessDate,
  reportCollectionsFilterEconomicAccountingEndBusinessDateSelector,
  reportCollectionsFilterEconomicAccountingStartBusinessDateSelector,
} from '../../state';
import { DateRangeFlexSalesProps } from '../DateRangeFlexSales';
import ReportBusinessDateRangeFilter from '../ReportFilters/filters/BusinessDateRangeFilter';

type BusinessDateRangeFilterProps = Pick<
  DateRangeFlexSalesProps<Date>,
  'spacing' | 'requiredIncomplete'
>;

const EconomicAccountingBusinessDateRangeFilter = (props: BusinessDateRangeFilterProps) => (
  <ReportBusinessDateRangeFilter
    {...props}
    maxDate={constants.reportCollectionsFilterRangeMaxDate}
    startDateSelector={reportCollectionsFilterEconomicAccountingStartBusinessDateSelector}
    endDateSelector={reportCollectionsFilterEconomicAccountingEndBusinessDateSelector}
    changeStartDateAction={changeCollectionsEconomicAccountingFilterStartBusinessDate}
    changeEndDateAction={changeCollectionsEconomicAccountingFilterEndBusinessDate}
  />
);

export default EconomicAccountingBusinessDateRangeFilter;
